import { ProdAdminService } from "src/app/admin/admin.service";
import { AuthorizationService } from "src/app/authorization/services/authorization.service";
import { SpSettingsService } from "src/app/settings/spSettingsService";
import { ProdSubstituteService } from "src/app/substitute/substitute.service";
import {
  CirculationsService,
  SpPeopleService,
  SpUserService
} from "../app/services";

export const environment = {
  assets: {
    logo: "./assets/images/ECELogoSmall.png"
  },
  production: true,
  i18n: {
    options: {
      supportedLngs: ["en", "de"],
      nonExplicitWhitelist: true,
      fallbackLng: "de",
      debug: false,
      returnEmptyString: false,

      //backend plugin options
      backend: {
        loadPath: "./assets/i18n/{{lng}}.json"
      },
      // lang detection plugin options
      detection: {
        // order and from where user language should be detected
        order: ["cookie"],

        // keys or params to lookup language from
        lookupCookie: "lang",

        // cache user language on
        caches: ["cookie"],

        // optional expire and domain for set cookie
        cookieMinutes: 10080, // 7 days
        cookieDomain: "I18NEXT_LANG_COOKIE_DOMAIN"
      }
    }
  },
  services: {
    user: SpUserService,
    circulations: CirculationsService,
    people: SpPeopleService,
    settings: SpSettingsService,
    authorization: AuthorizationService,
    substitute: ProdSubstituteService,
    admin: ProdAdminService
  }
};
